import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import Helmet from 'react-helmet'

// Utils
import getFormValue from '../../../util/getFormValue'

//components
import { Box, ButtonLink, Title, Row, ButtonClose, Column, Or } from '../../../components/UserInterface'
import ModalDefault from '../../../components/modal/ModalDefault'
import FormValidation from '../../../components/FormValidation'
import BtnSubmit from '../../../components/button/BtnSubmit'

// Component Global
import {
  FirstName,
  LastName,
  Email,
  Password,
  SocialSignInAll
} from './components/AuthForms'

// Import Actions
import { signUp } from '../../../redux/Auth/AuthActions'

class SignUp extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  handleSubmit = (e, formName) => {
    e.preventDefault()
    const params = getFormValue(this.refs[formName])

    if (params) {
      this.props.dispatch(signUp({
        body: params,
        loadId: formName,
        errorAlert: true,
        props: this.props,
        redirect: { url: '/confirm-account' },
        toastMsg: 'กรุณายืนยันการสมัครทางอีเมล'
      }))
    }
  }

  render() {
    return (
      <div>
        <Helmet title="สมัครสมาชิก" />
        <ModalDefault showOnly={true} bgOverlay="#7cb342" width="380px">
          <Box padding="30px 30px 0 30px" background="#fff">
            <ButtonClose to={`/`} />
            <Title align="center" title="สมัครสมาชิก" />

            <SocialSignInAll {...this.props} />

            <Or text="สมัครสมาชิกด้วยอีเมล" />

            <Row>
              <FormValidation ref="signup" name="signup" submit={(e) => this.handleSubmit(e, 'signup')}>
                <Column col="column col-xxs-12">
                  <FirstName />
                </Column>
                <Column col="column col-xxs-12">
                  <LastName />
                </Column>
                <Column col="column col-xxs-12">
                  <Email />
                </Column>
                <Column col="column col-xxs-12">
                  <Password />
                </Column>

                <Column col="column col-xxs-12 mg-top-10 text-right">
                  <BtnSubmit
                    loadingId="signup"
                    icon="lock_open"
                    iconAlign="left"
                    text="สมัครสมาชิก"
                    className="waves-effect waves-light btn light-green darken-1 width-full-xs"
                    btnDisabled
                  />
                </Column>
              </FormValidation>
            </Row>

            <Row align="center">
              <div style={{ borderTop: '1px solid #eee', margin: '20px -30px 0 -30px' }}>
                <div style={{ width: '50%', float: 'left' }}>
                  <Link to="forgot-password" style={{ lineHeight: '35px' }}>ลืมรหัสผ่าน</Link>
                </div>
                <div style={{ borderLeft: '1px solid #eee', width: '50%', float: 'left' }}>
                  <Link to="signin" style={{ lineHeight: '40px' }}>เข้าสู่ระบบ</Link>
                </div>
              </div>
            </Row>
          </Box>

        </ModalDefault>
      </div>
    )
  }
}


function mapStateToProps(state) {
  return {
    app: state.app,
    auth: state.auth
  }
}

export default withRouter(connect(mapStateToProps)(SignUp))
